import { Component, DoCheck, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { ReplaySubject, Subscription } from 'rxjs';

import { LayoutHostDirective } from '../../components/layout-host.directive';
import { DynamicFormDataModel, DynamicFormDataModelData } from '../../dynamic-form/utils/dynamic-form-context.type';
import { ControlSharedService } from '../../services/control-shared.service';
import { ControlTranslateService } from '../../services/control-translate.service';
import { ControlValidatorService } from '../../services/control-validator.service';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlBroadCastEvent } from '../../types/control-broadcast';
import { ShowHiddenRuleModel } from '../../types/control-show-hidden.types';
import {
  AbstractControl,
  ControlDataModel,
  ControlViewModel,
  ValueControlViewModel,
  ControlOperateMode
} from '../../types/control.types';
import {
  bindCascade,
  bindUnionCheck,
  camelCaseObject,
  controlsTraversalPipe,
  controlsTraversalPipeReturn,
  ControlTranslate,
  setControlValidator
} from '../../utils';
import {
  DynamicFormEvent,
  DynamicFormEventType,
  executeFormEvent,
  toDynamicFormModel
} from '../../utils/dynamic-form-model';
import { AbstractDynamicForm } from '../abstract-dynamic-form';
import { DynamicFormRunHelperService } from '../services/dynamic-form-run-helper.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css'],
  providers: [ControlTranslateService]
})
export class DynamicFormComponent extends AbstractDynamicForm implements OnInit, DoCheck, OnDestroy {
  labelCode?: string;
  @Input() isBindValueChange = true;

  @Input() set controlSharedService(controlSharedService: ControlSharedService) {
    this._controlSharedService = controlSharedService;
  }

  @Input()
  set formCode(formCode: string) {
    this._formCode = formCode;
    this._dataModel.formCode = formCode;
    // this.loadFormContent();
  }
  get formCode(): string {
    return this._formCode;
  }

  @Input()
  set dataModel(context: DynamicFormDataModel) {
    this._dataModel = context;
  }
  get dataModel(): DynamicFormDataModel {
    return this._dataModel;
  }

  @Input() set targetId(val: string) {
    this._targetId = val;
    if (!this.formLoading) {
    }
  }
  get targetId(): string {
    return this._targetId;
  }

  @Input() set isAdd(value: boolean) {
    this._isAdd = value;
  }

  @Input()
  set readOnly(readOnly: boolean) {
    this._readOnly = readOnly;
    // this.setReadOnly();
  }

  get readOnly(): boolean {
    return this._readOnly;
  }

  @Input()
  set enableEditAtView(enableEditAtView: boolean) {
    this._enableEditAtView = enableEditAtView;
  }

  get enableEditAtView(): boolean {
    return this._enableEditAtView;
  }

  @Input()
  set enableEditNameList(enableEditNameList: string[]) {
    this._enableEditNameList = enableEditNameList;
    // this.setReadOnly();
  }
  get enableEditNameList(): string[] {
    return this._enableEditNameList;
  }

  @Input() set model(val: any) {
    const formModel = toDynamicFormModel(val);
    this.formEventModels = formModel.form.events;
    this.showHiddenRuleModels = formModel.form.showHiddenRules;
    this.controlDataModels = formModel.controls;
    this.loadComponents(this.controlDataModels);
  }

  @Input() set value(value: any) {
    if (!this._isAdd) {
      this.setControlsValue(value);
      this.triggerDefaultCascade();
      this.bindShowHiddenRule(this.showHiddenRuleModels);
    }
  }

  /**
   * è¡¨åç¶æ
   */
  get valid(): boolean {
    return this._valid;
  }

  get valueChanged$() {
    return this._valueChanged.asObservable();
  }

  @Output() beforeLoad: EventEmitter<any> = new EventEmitter();
  @Output() afterLoad: EventEmitter<any> = new EventEmitter();
  @Output() beforeDataLoad: EventEmitter<any> = new EventEmitter();
  @Output() afterDataLoad: EventEmitter<any> = new EventEmitter();
  @Output() controlBroadCast: EventEmitter<ControlBroadCastEvent> = new EventEmitter<ControlBroadCastEvent>();

  /**
   * æ°æ®Id
   *
   */
  dataId: string;

  controlTranslate: ControlTranslate;
  controls: AbstractControl<ControlViewModel>[];
  private formLoading: boolean = true;

  private formEventModels: Array<DynamicFormEvent>;
  private showHiddenRuleModels: Array<ShowHiddenRuleModel>;
  private controlDataModels: Array<ControlDataModel>;
  private _loadComponentModelSubscription: Subscription;
  private _controlResolvedSubscription: Subscription;
  private _globalData: any;
  private _readOnly: boolean;
  private _enableEditAtView: boolean;
  private _enableEditNameList: string[] = [];
  private _isAdd: boolean;
  private _targetId: string;
  private _formCode: string;
  private _dataModel: DynamicFormDataModel = { targetId: '0', formCode: '', data: undefined };
  private _valid: boolean;
  private _controlSharedService: ControlSharedService;

  // è§£å³å­è¡¨åçæ°æ®åå¨ä¹åï¼å­è¡¨åæ§ä»¶å¹¶åæ¶ä¸è½æ¥åå°
  private _valueChanged = new ReplaySubject<DynamicFormDataModelData>(1);

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;

  constructor(
    private controlTranslateService: ControlTranslateService,
    private controlValidatorService: ControlValidatorService,
    private runHelperService: DynamicFormRunHelperService
  ) {
    super();
    this.controlTranslate = this.controlTranslateService;
    this._loadComponentModelSubscription = this.controlTranslateService.loadComponentModel$.subscribe((s) => {
      this.controlTranslateService.loadComponentsByModel(s);
    });
    this.subscribeControlResolved();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this._loadComponentModelSubscription.unsubscribe();
    this._controlResolvedSubscription.unsubscribe();
  }

  ngDoCheck(): void {
    this._valid = this.getValid();
  }

  getValid() {
    if (this.formLoading || !this.controls) {
      return false;
    }

    let isValid = true;

    controlsTraversalPipeReturn(this.controls, (c) => {
      if (c.hidden) {
        return null;
      }

      if (!c.valid) {
        isValid = false;
        return isValid;
      }
      return null;
    });
    return isValid;
  }

  /**
   * è®¾ç½®æ§ä»¶readonlyç¶æ
   */
  setReadOnly() {
    controlsTraversalPipe(this.controls, (c) => this.setControlReadOnly(c));
  }

  /**
   * è®¾ç½®æææ§ä»¶å¼
   */
  setControlsValue(dataValue: DynamicFormDataModel) {
    this.dataId = dataValue.id;
    controlsTraversalPipe(this.controls, (c) =>
      this.runHelperService.setControlValue(c, dataValue.data, this.targetId)
    );
  }

  // è·åå½åè¡¨åæ°æ®
  getCurrentDataModel(targetId: string): DynamicFormDataModel {
    this._dataModel.targetId = targetId;
    this._dataModel.data = this.runHelperService.getControlsValue(this.controls);
    this._dataModel.id = this.dataId;
    return this._dataModel;
  }

  // æ¸ç©ºè¡¨å
  clear() {
    super.clear(this.runHelperService);
  }

  private loadComponents(dataModels: Array<ControlDataModel>) {
    this.formLoading = true;
    this.beforeLoad.emit();
    executeFormEvent(this.formEventModels, DynamicFormEventType.BeforeLoad, this);

    dataModels = camelCaseObject(dataModels);
    dataModels = this.controlTranslateService.filterNotDisplayControl(dataModels);
    const controls = this.controlTranslateService.loadComponents(dataModels, this, false);
    this.controls = controls;

    executeFormEvent(this.formEventModels, DynamicFormEventType.AfterLoad, this);
    this.formLoading = false;

    controlsTraversalPipe(
      this.controls,
      (c) => {
        bindCascade(c, this.controls);
        bindUnionCheck(c, this.controls);
        this.bindValueChange(c as AbstractValueControlBase<any>);
      },
      (c) => this.runHelperService.setControlFormCode(c, this.formCode),
      (c) => this.setControlReadOnly(c),
      (c) => this.setControlOperateMode(c)
    );
    this.bindShowHiddenRule(this.showHiddenRuleModels);
  }

  private subscribeControlResolved() {
    this._controlResolvedSubscription = this.controlTranslateService.controlResolved.subscribe((s) => {
      s.controlShared = this._controlSharedService;
      s.dataConfig.targetId = this.targetId;
      setControlValidator(s, this.controlValidatorService);
    });
  }

  /**
   * è®¾ç½®æ§ä»¶åªè¯»
   */
  private setControlReadOnly(control: AbstractControl<any>) {
    if (control) {
      control.viewOnly = this._readOnly;
      control.enableEditAtView = this._enableEditAtView;
      control.enableEditNameList = this._enableEditNameList;
    }
  }

  /**
   * è®¾ç½®æ§ä»¶åªè¯»
   */
  setControlOperateMode(control: AbstractControl<any>) {
    if (control && control instanceof AbstractValueControlBase) {
      if (this._isAdd) {
        control.operateMode = ControlOperateMode.Add;
        return;
      }
      if (this._readOnly) {
        control.operateMode = ControlOperateMode.View;
        return;
      }
      control.operateMode = ControlOperateMode.Edit;
    }
  }

  private bindValueChange(control: AbstractValueControlBase<ValueControlViewModel>) {
    if (!control.valueChanged$) {
      return;
    }
    control.valueChanged$.subscribe((s) => {
      if (this.isBindValueChange) {
        this._valueChanged.next(this.runHelperService.getControlsValue(this.controls));
      }
    });
  }
}
